import request from "@/utils/request";
/**
 * 请求二维码数据
 * @param {Object} params
 */
export function qrCode(params) {
  return request({
    url: "qrcode/get",
    method: "get",
    params,
  });
}

/**
 * 手机扫码回调
 * @param {Object} params
 */
export function codeCallback(params) {
  return request({
    url: "qrcode/redirect",
    method: "get",
    params,
  });
}

/**
 * 扫码定时查询
 * @param {Object} params
 */
export function codeQuery(params) {
  return request({
    url: "qrcode/state",
    method: "get",
    params,
  });
}

/**
 * 扫码登录
 * @param {Object} data
 */
export function codeLogin(data) {
  return request({
    url: "qrcode/login",
    method: "post",
    data,
  });
}

/**
 * 扫码绑定
 * @param {Object} data
 */
export function codeBinding(data) {
  return request({
    url: "qrcode/binding",
    method: "post",
    data,
  });
}

/**
 * 账号登录
 * @param {Object} data
 */
export function login(data) {
  return request({
    url: "auth/login",
    method: "post",
    data,
  });
}

/**
 * 修改密码
 * @param {Object} data
 */
export function changePwd(data) {
  return request({
    url: "change/pwd",
    method: "post",
    data,
  });
}

/**
 * 年级列表
 * @param {Object} params
 */
export function gradeList(params) {
  return request({
    url: "grade/list",
    method: "get",
    params,
  });
}

/**
 * 获取年级对应班级列表
 * @param {Object} params
 */
export function classOfGradeList(params) {
  return request({
    url: "grade/class",
    method: "get",
    params,
  });
}

/**
 * 获取年级班级级联列表
 * @param {Object} params
 */
export function classCascade(params) {
  return request({
    url: "grade/class_cascade",
    method: "get",
    params,
  });
}

/**
 * 班级列表
 * @param {Object} params
 */
export function classList(params) {
  return request({
    url: "list/class",
    method: "get",
    params,
  });
}

/**
 * 我的课程列表
 * @param {Object} params
 */
export function myCourseList(params) {
  return request({
    url: "lesson/list_my",
    method: "get",
    params,
  });
}

/**
 * 搜索课程列表
 * @param {Object} params
 */
export function searchCourseList(params) {
  return request({
    url: "list/lesson",
    method: "get",
    params,
  });
}

/**
 * 获取分类课程列表
 * @param {Object} params
 */
export function getCategoryCourseList(params) {
  return request({
    url: "category/list_lesson",
    method: "get",
    params,
  });
}

/**
 * 我的课程详情
 * @param {Object} params
 */
export function myCourseGet(params) {
  return request({
    url: "get/lesson",
    method: "get",
    params,
  });
}

/**
 * 共享课程列表
 * @param {Object} params
 */
export function sharedCoursesList(params) {
  return request({
    url: "lesson/list_shared",
    method: "get",
    params,
  });
}

/**
 * 添加课程
 * @param {Object} data
 */
export function addLesson(data) {
  return request({
    url: "lesson/add",
    method: "post",
    data,
  });
}

/**
 * 课程分类添加和修改
 * @param {Object} data
 */
export function categoryAddOrEdit(data) {
  return request({
    url: "category/add_edit",
    method: "post",
    data,
  });
}

/**
 * 修改课程基本信息
 * @param {Object} data
 */
export function reviseLesson(data) {
  return request({
    url: "lesson/edit",
    method: "post",
    data,
  });
}
/**
 * 修改课程基本信息
 * @param {Object} data
 */
export function editLesson(data) {
  return request({
    url: "edit/lesson",
    method: "post",
    data,
  });
}

/**
 * 添加课程其他信息
 * @param {Object} data
 */
export function addOtherInformation(data) {
  return request({
    url: "lesson/add_ext",
    method: "post",
    data,
  });
}

/**
 * 删除课程其他信息
 * @param {Object} data
 */
export function delOtherInformation(data) {
  return request({
    url: "lesson/del_ext",
    method: "post",
    data,
  });
}

/**
 * 课程课次列表
 * @param {Object} params
 */
export function courseTimesList(params) {
  return request({
    url: "lesson_item/list",
    method: "get",
    params,
  });
}

/**
 * 课程分类列表
 * @param {Object} params
 */
export function courseClassificationList(params) {
  return request({
    url: "list/category",
    method: "get",
    params,
  });
}

/**
 * 课程分类基础统计数
 * @param {Object} params
 */
export function basicDataOfCourseClassification(params) {
  return request({
    url: "statis/lesson/category_summary",
    method: "get",
    params,
  });
}

/**
 * 课程分类次数统计数据
 * @param {Object} params
 */
export function statisticalDataOfCourseClassification(params) {
  return request({
    url: "statis/lesson/category_num",
    method: "get",
    params,
  });
}

/**
 * 课程基础统计数据
 * @param {Object} params
 */
export function courseBasicStatisticalData(params) {
  return request({
    url: "statis/lesson/summary",
    method: "get",
    params,
  });
}

/**
 * 课程次数统计数据
 * @param {Object} params
 */
export function courseStatisticsData(params) {
  return request({
    url: "statis/lesson/num",
    method: "get",
    params,
  });
}

/**
 * 课次添加
 * @param {Object} data
 */
export function classAddition(data) {
  return request({
    url: "lesson_item/add",
    method: "post",
    data,
  });
}

/**
 * 课次修改
 * @param {Object} data
 */
export function courseRevision(data) {
  return request({
    url: "lesson_item/edit",
    method: "post",
    data,
  });
}

/**
 * 课次删除
 * @param {Object} data
 */
export function classDeletion(data) {
  return request({
    url: "lesson_item/del",
    method: "post",
    data,
  });
}

/**
 * 获取资源列表
 * @param {Object} params
 */
export function resourceList(params) {
  return request({
    url: "lesson_item/get_assets",
    method: "get",
    params,
  });
}

/**
 * 资源添加
 * @param {Object} data
 */
export function resourceAddition(data) {
  return request({
    url: "assets/add",
    method: "post",
    data,
  });
}

/**
 * 资源修改
 * @param {Object} data
 */
export function resourceModification(data) {
  return request({
    url: "assets/edit",
    method: "post",
    data,
  });
}

/**
 * 资源关联添加
 * @param {Object} data
 */
export function resourceAssociationAdd(data) {
  return request({
    url: "link_resource/add",
    method: "post",
    data,
  });
}

/**
 * 资源关联删除
 * @param {Object} data
 */
export function resourceAssociationDel(data) {
  return request({
    url: "link_resource/del",
    method: "post",
    data,
  });
}

/**
 * 习题添加
 * @param {Object} data
 */
export function exerciseAddition(data) {
  return request({
    url: "exam_item/add",
    method: "post",
    data,
  });
}

/**
 * 习题修改
 * @param {Object} data
 */
export function exerciseModification(data) {
  return request({
    url: "exam_item/edit",
    method: "post",
    data,
  });
}

/**
 * 习题删除
 * @param {Object} data
 */
export function exerciseDeletion(data) {
  return request({
    url: "exam_item/del",
    method: "post",
    data,
  });
}

/**
 * 作业添加
 * @param {Object} data
 */
export function testPaperAddition(data) {
  return request({
    url: "exam/add",
    method: "post",
    data,
  });
}

/**
 * 作业修改
 * @param {Object} data
 */
export function testPaperModification(data) {
  return request({
    url: "exam/edit",
    method: "post",
    data,
  });
}

/**
 * 作业试题修改分数
 * @param {Object} data
 */
export function testPaperModifyTestScores(data) {
  return request({
    url: "exam/addedit_item",
    method: "post",
    data,
  });
}

/**
 * 作业批量添加试题
 * @param {Object} data
 */
export function batchAddTestQuestions(data) {
  return request({
    url: "exam/batch_addedit_item",
    method: "post",
    data,
  });
}

/**
 * 作业自动生成
 * @param {Object} data
 */
export function autoGenerate(data) {
  return request({
    url: "exam_item/gen",
    method: "post",
    data,
  });
}

/**
 * 作业详情
 * @param {Object} params
 */
export function testPaperDetails(params) {
  return request({
    url: "exam/get",
    method: "get",
    params,
  });
}

/**
 * 作业删除试题
 * @param {Object} data
 */
export function deleteTestQuestions(data) {
  return request({
    url: "exam/del_item",
    method: "post",
    data,
  });
}

/**
 * 作业添加课次
 * @param {Object} data
 */
export function testPaperAddClass(data) {
  return request({
    url: "exam/add_lession_item",
    method: "post",
    data,
  });
}

/**
 * 作业删除课次
 * @param {Object} data
 */
export function testPaperDelClass(data) {
  return request({
    url: "exam/del_lession_item",
    method: "post",
    data,
  });
}

/**
 * 发布上课资源
 * @param {Object} data
 */
export function publishClassResources(data) {
  return request({
    url: "lession/publish",
    method: "post",
    data,
  });
}

/**
 * 课次习题学生记录
 * @param {Object} params
 */
export function courseLearningRecords(params) {
  return request({
    url: "lesson_item/exam_item_list",
    method: "get",
    params,
  });
}

/**
 * 年级学生学习记录
 * @param {Object} params
 */
export function gradeLearningRecords(params) {
  return request({
    url: "lesson_item/grade_list",
    method: "get",
    params,
  });
}

/**
 * 学生学习记录修改
 * @param {Object} data
 */
export function learningRecordsModification(data) {
  return request({
    url: "lesson_user/score_modify",
    method: "post",
    data,
  });
}

/**
 * 获取老师授课班级列表
 * @param {Object} params
 */
export function obtainTeacherTeachingClass(params) {
  return request({
    url: "teacher/lesson_class_list",
    method: "get",
    params,
  });
}

/**
 * 添加老师授课班级
 * @param {Object} data
 */
export function addTeacherTeachingClass(data) {
  return request({
    url: "teacher/lesson_class_add",
    method: "post",
    data,
  });
}

/**
 * 删除老师授课班级
 * @param {Object} data
 */
export function delTeacherTeachingClass(data) {
  return request({
    url: "teacher/lesson_class_del",
    method: "post",
    data,
  });
}

/**
 * 获取学生列表数据
 * @param {Object} params
 */
export function studentList(params) {
  return request({
    url: "list/user",
    method: "get",
    params,
  });
}

/**
 * 修改学生密码
 * @param {Object} data
 */
export function changeStudentPassword(data) {
  return request({
    url: "edit/user",
    method: "post",
    data,
  });
}

/**
 * 添加班级学生
 * @param {Object} data
 */
export function addClassStudents(data) {
  return request({
    url: "add/user",
    method: "post",
    data,
  });
}

/**
 * 删除班级学生
 * @param {Object} data
 */
export function delClassStudents(data) {
  return request({
    url: "del/user",
    method: "post",
    data,
  });
}

/**
 * 删除课程
 * @param {Object} data
 */
export function delLesson(data) {
  return request({
    url: "del/lesson",
    method: "post",
    data,
  });
}

/**
 * 获取是否答题记录数据
 * @param {Object} params
 */
export function answerRecord(params) {
  return request({
    url: "list/lesson_user",
    method: "get",
    params,
  });
}

/**
 * 各分值占比设置
 * @param {Object} data
 */
export function scorePercentageSetting(data) {
  return request({
    url: "score/set_percent",
    method: "post",
    data,
  });
}

/**
 * 获取表现分、期中考试分数、期末考试分数列表
 * @param {Object} params
 */
export function getScoreList(params) {
  return request({
    url: "list/ext_score",
    method: "get",
    params,
  });
}
// 2024-03-04
/**
 * 首页数据
 * @param {Object} params
 */
export function getHomeData(params) {
  return request({
    url: "index/list",
    method: "get",
    params,
  });
}
/**
 * 课程或教材数据
 * @param {Object} params
 */
export function getCoursesOrTextbooksData(params) {
  return request({
    url: "index/types",
    method: "get",
    params,
  });
}
/**
 * 课程分类数据
 * @param {Object} params
 */
export function getCourseClassificationData(params) {
  return request({
    url: "category/list",
    method: "get",
    params,
  });
}
/**
 * 教材数据
 * @param {Object} params
 */
export function getBookClassificationData(params) {
  return request({
    url: "book/list",
    method: "get",
    params,
  });
}
// 2024-04-05
/**
 * 复制课程
 * @param {Object} data
 */
export function courseDuplication(data) {
  return request({
    url: "lesson/copy",
    method: "post",
    data,
  });
}
/**
 * 获取课程列表
 * @param {Object} params
 */
export function getCourseList(params) {
  return request({
    url: "list/lesson",
    method: "get",
    params,
  });
}
/**
 * 获取老师列表数据
 * @param {Object} params
 */
export function teacherList(params) {
  return request({
    url: "list/user",
    method: "get",
    params,
  });
}
/**
 * 是否可以查看课程
 * @param {Object} params
 */
export function canBeViewed(params) {
  return request({
    url: "share/is_auth",
    method: "get",
    params,
  });
}
/**
 * 请求分享查看
 * @param {Object} data
 */
export function requestToShare(data) {
  return request({
    url: "share/req",
    method: "post",
    data,
  });
}
/**
 * 获取消息列表
 * @param {Object} params
 */
export function getMessageList(params) {
  return request({
    url: "page/link_shared",
    method: "get",
    params,
  });
}
/**
 * 审核分享
 * @param {Object} data
 */
export function viewExamine(data) {
  return request({
    url: "share/audit",
    method: "post",
    data,
  });
}

/**
 * 获取消息数量
 * @param {Object} params
 */
export function getMessageNum(params) {
  return request({
    url: "count/link_shared",
    method: "get",
    params,
  });
}

/**
 * 获取教材列表
 * @param {Object} params
 */
export function getTextbookList(params) {
  return request({
    url: "list/book",
    method: "get",
    params,
  });
}

/**
 * 获取我的教材列表
 * @param {Object} params
 */
export function getMyTextbookList(params) {
  return request({
    url: "book/list_my",
    method: "get",
    params,
  });
}

/**
 * 根据课程获取教材接口
 * @param {Object} params
 */
export function courseGetTextbook(params) {
  return request({
    url: "lesson/get_book",
    method: "get",
    params,
  });
}

/**
 * 根据教材获取课程接口
 * @param {Object} params
 */
export function textbookGetCourse(params) {
  return request({
    url: "book/get_lesson",
    method: "get",
    params,
  });
}

/**
 * 单条获取教材列表
 * @param {Object} params
 */
export function getSingleTextbook(params) {
  return request({
    url: "get/book",
    method: "get",
    params,
  });
}

/**
 * 添加教材
 * @param {Object} data
 */
export function addTextbook(data) {
  return request({
    url: "add/book",
    method: "post",
    data,
  });
}

/**
 * 修改教材
 * @param {Object} data
 */
export function editTextbook(data) {
  return request({
    url: "edit/book",
    method: "post",
    data,
  });
}

/**
 * 获取教材目录
 * @param {Object} params
 */
export function getTextbookCatalogue(params) {
  return request({
    url: "book/item_list",
    method: "get",
    params,
  });
}

/**
 * 添加教材目录
 * @param {Object} data
 */
export function addTextbookCatalogue(data) {
  return request({
    url: "add/book_item",
    method: "post",
    data,
  });
}

/**
 * 修改教材目录
 * @param {Object} data
 */
export function editTextbookCatalogue(data) {
  return request({
    url: "edit/book_item",
    method: "post",
    data,
  });
}

/**
 * 删除教材目录
 * @param {Object} data
 */
export function delTextbookCatalogue(data) {
  return request({
    url: "del/book_item",
    method: "post",
    data,
  });
}

/**
 * 教材纸质封面上传
 * @param {Object} data
 */
export function uploadTextbookPaper(data) {
  return request({
    url: "book/link_res/add",
    method: "post",
    data,
  });
}

/**
 * 教材纸质封面修改
 * @param {Object} data
 */
export function editTextbookPaper(data) {
  return request({
    url: "book/link_res/edit",
    method: "post",
    data,
  });
}

/**
 * 教材纸质封面删除
 * @param {Object} data
 */
export function delTextbookPaper(data) {
  return request({
    url: "book/link_res/del",
    method: "post",
    data,
  });
}

/**
 * 获取教材目录数据
 * @param {Object} params
 */
export function getTextbookCatalogueData(params) {
  return request({
    url: "book/item_link_data",
    method: "get",
    params,
  });
}

/**
 * 教材侧边资源关联添加
 * @param {Object} data
 */
export function addTextbookSidebar(data) {
  return request({
    url: "book/link_ext/add",
    method: "post",
    data,
  });
}

/**
 * 教材侧边资源关联删除
 * @param {Object} data
 */
export function delTextbookSidebar(data) {
  return request({
    url: "book/link_ext/del",
    method: "post",
    data,
  });
}

/**
 * AR图片添加
 * @param {Object} data
 */
export function addArImg(data) {
  return request({
    url: "ar/add_edit",
    method: "post",
    data,
  });
}

/**
 * AR图片删除
 * @param {Object} data
 */
export function delArImg(data) {
  return request({
    url: "ar/delete",
    method: "post",
    data,
  });
}

/**
 * 教材资源上传导入
 * @param {Object} data
 */
export function textbookIntroduction(data) {
  return request({
    url: "import/book",
    method: "post",
    data,
  });
}

/**
 * 教材资源上传导入
 * @param {Object} params
 */
export function arImgList(params) {
  return request({
    url: "list/link_book_res",
    method: "get",
    params,
  });
}

/**
 * 资源关联获取
 * @param {Object} params
 */
export function getLinkResource(params) {
  return request({
    url: "link_resource/get",
    method: "get",
    params,
  });
}

/**
 * 获取AR图片列表
 * @param {Object} params
 */
export function getARImageList(params) {
  return request({
    url: "list/ar_image",
    method: "get",
    params,
  });
}

/**
 * 获取班级积分
 * @param {Object} params
 */
export function getClassScore(params) {
  return request({
    url: "lesson_user/class_score",
    method: "get",
    params,
  });
}

/**
 * 获取互动详情列表
 * @param {Object} params
 */
export function getH5Detail(params) {
  return request({
    url: "list/ext_item",
    method: "get",
    params,
  });
}

/**
 * 清空用户绑定
 * @param {Object} data
 */
export function clearBind(data) {
  return request({
    url: "user/clear_bind",
    method: "post",
    data,
  });
}

/**
 * 是否可以查看教材
 * @param {Object} params
 */
export function whetherViewTextbook(params) {
  return request({
    url: "book/is_auth",
    method: "get",
    params,
  });
}

/**
 * 获取作业列表
 * @param {Object} params
 */
export function getExamList(params) {
  return request({
    url: "list/exam",
    method: "get",
    params,
  });
}

/**
 * 删除作业
 * @param {Object} data
 */
export function delExam(data) {
  return request({
    url: "del/exam",
    method: "post",
    data,
  });
}

/**
 * 导入作业
 * @param {Object} data
 */
export function importExam(data) {
  return request({
    url: "import/exam_item",
    method: "post",
    data,
  });
}

/**
 * 作业批阅
 * @param {Object} data
 */
export function examReadOver(data) {
  return request({
    url: "lesson_user/readed",
    method: "post",
    data,
  });
}

/**
 * 获取作业批阅详情
 * @param {Object} params
 */
export function getExamReadOver(params) {
  return request({
    url: "lesson_user/not_readed",
    method: "get",
    params,
  });
}

/**
 * 获取评分统计
 * @param {Object} params
 */
export function getStudentScore(params) {
  return request({
    url: "statis/score/class",
    method: "get",
    params,
  });
}

/**
 * 获取作业评分统计
 * @param {Object} params
 */
export function getStudentExamScore(params) {
  return request({
    url: "statis/score/class_exam",
    method: "get",
    params,
  });
}

/**
 * 获取资源数量
 * @param {Object} params
 */
export function getCountAssets(params) {
  return request({
    url: "count/assets",
    method: "get",
    params,
  });
}

/**
 * 获取个人作业数据详情
 * @param {Object} params
 */
export function getPersonalTestPaperData(params) {
  return request({
    url: "statis/score/user_exam",
    method: "get",
    params,
  });
}

/**
 * 修改试题
 * @param {Object} data
 */
export function editExam_item(data) {
  return request({
    url: "edit/exam_item",
    method: "post",
    data,
  });
}

/**
 * 获取星图数据
 * @param {Object} params
 */
export function getStarCloud(params) {
  return request({
    url: "ai/star_cloud",
    method: "get",
    params,
  });
}